// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ core
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const { LabelDate } = require('commonsComponents/labelDate');

class AccountPrecautionaryWarningsDetailRow extends React.Component {
    buildLabelDate(fieldName) {
        const { immTransaction } = this.props;
        const language = getLanguage();

        return immTransaction.get(fieldName) ? (
            <LabelDate
                date={immTransaction.get(fieldName)}
                language={language}
                today={<FormattedText value="labelDate-today" />}
                yesterday={<FormattedText value="labelDate-yesterday" />}
            />
        ) : '-';
    }

    render() {
        const { immTransaction, id } = this.props;

        return (
            <OKTableRow id={id}>
                <OKTableCell>
                    {this.buildLabelDate('date')}
                </OKTableCell>
                <OKTableCell>
                    {immTransaction.get('typology', '-')}
                </OKTableCell>
                <OKTableCell>
                    {immTransaction.get('description', '-')}
                </OKTableCell>
                <OKTableCell>
                    {this.buildLabelDate('startDate')}
                </OKTableCell>
                <OKTableCell>
                    {this.buildLabelDate('endDate')}
                </OKTableCell>
            </OKTableRow>
      );
    }
}

AccountPrecautionaryWarningsDetailRow.propTypes = {
    immTransaction: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
}

module.exports = AccountPrecautionaryWarningsDetailRow;
